import React from 'react';
import { users } from 'types';
import DialogConfirm from 'components/dialog/dialog-confirm';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import LockIcon from '@material-ui/icons/Lock';
import { CellButtonContentStyled } from '../index.styled';
import useUserUnlock from '../hooks/use-user-unlock';

const DialogUnlock = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data?: users.TUsersDetail } & TDialogWrapperComponent) => {
    const [onUnlock] = useUserUnlock(asyncStatesHandlers);

    return (
        <DialogConfirm<users.TUsers>
            isDialogOpen={!!data && isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={<>Confirm user unlock</>}
            labels={{
                onOk: (
                    <CellButtonContentStyled>
                        <LockIcon /> Unlock
                    </CellButtonContentStyled>
                ),
            }}
            onOk={async () => {
                if (!data || !data.id) {
                    console.error('No ID');
                    return;
                }
                try {
                    await onUnlock({ id: data.id });
                } catch (e) {}
            }}
        />
    );
};

export default DialogUnlock;
